module.exports = __webpack_public_path__ + "media/svg/phone-5109ff5a.svg";